
import React from 'react';

const Hero: React.FC = () => {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative pt-32 pb-20 md:pt-48 md:pb-40 overflow-hidden bg-slate-950">
      {/* Subtle background glow effects */}
      <div className="absolute top-0 left-1/4 w-[500px] h-[500px] bg-blue-600/20 rounded-full blur-[120px] pointer-events-none"></div>
      <div className="absolute bottom-0 right-1/4 w-[500px] h-[500px] bg-purple-600/10 rounded-full blur-[120px] pointer-events-none"></div>
      
      <div className="container mx-auto px-6 relative z-10">
        <div className="flex flex-col items-center text-center max-w-4xl mx-auto">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-white/5 border border-white/10 mb-8 shadow-sm backdrop-blur-md">
            <span className="w-2 h-2 bg-blue-400 rounded-full animate-pulse"></span>
            <span className="text-xs font-bold tracking-widest text-blue-300 uppercase">Platform Architect</span>
          </div>
          
          <h1 className="text-5xl md:text-8xl font-black text-white leading-[1.1] mb-8 tracking-tight">
            Design <span className="gradient-text">Build</span> <br />
            Launch <span className="text-slate-500 italic font-light">&</span> Grow
          </h1>

          <p className="text-lg md:text-xl text-slate-400 mb-12 max-w-2xl leading-relaxed font-medium">
            We design, build, and maintain custom web applications for small businesses—delivering scalable, high-performance solutions with ongoing hosting and support.
          </p>
          
          <div className="flex flex-col sm:flex-row gap-6 w-full sm:w-auto">
            <button 
              onClick={() => scrollToSection('services')} 
              className="group relative px-10 py-5 bg-gradient-to-br from-blue-500 via-blue-600 to-purple-700 text-white font-black rounded-2xl shadow-xl shadow-blue-500/25 hover:scale-[1.03] hover:shadow-blue-500/40 active:scale-95 transition-all outline-none flex items-center justify-center gap-3 overflow-hidden"
            >
              {/* Gloss overlay effect */}
              <div className="absolute inset-0 bg-gradient-to-tr from-white/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity"></div>
              
              <span>Explore Services</span>
              <i className="fas fa-chevron-right text-sm group-hover:translate-x-1.5 transition-transform duration-300"></i>
            </button>
            
            <button 
              onClick={() => scrollToSection('work')} 
              className="group px-10 py-5 bg-white/5 backdrop-blur-md text-white font-bold rounded-2xl border border-white/10 hover:border-white/30 hover:bg-white/10 shadow-sm transition-all outline-none flex items-center justify-center gap-3 active:scale-95"
            >
              <i className="fas fa-briefcase text-slate-400 group-hover:text-white transition-colors"></i>
              <span>See Projects</span>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
